import { SettingsProps } from 'client/components/core/Sidebar/components/Settings/entities/index'
import { useUpdateProp } from 'client/components/core/Sidebar/components/Settings/hooks/useUpdateProps'
import { ButtonActionTypeEnum } from 'common/enums/ButtonActionTypeEnum'
import { addUrlSchemaToTheLink } from 'common/utils/urlUtils'
import React from 'react'
import { usePreserveEntityFieldsAcrossDiscriminator } from 'src/editor/hooks/use-preserve-fields-across-discriminator/use-preserve-entity-fields-across-discriminator'
import { TextInputControl } from 'src/editor/shared/settings/controls/text-input-control'
import { ActionButtonEntityInterface } from 'src/shared/entities/button/action-button.schema'
import { OpenUrlActionButtonEntityInterface } from 'src/shared/entities/button/open-url-action-button.schema'
import { OpenUrlWebsiteActionButtonEntityInterface } from 'src/shared/entities/website-button/open-url-website-button.schema'
import { WebsiteButtonEntityInterface } from 'src/shared/entities/website-button/website-button.schema'
import { useTypedTranslation } from 'src/shared/i18next/hooks/use-typed-translation'
import { ButtonLinkActionSettingsLayout } from './button-link-action-settings-layout'

type CommonActionButtonEntityInterface =
  | ActionButtonEntityInterface
  | WebsiteButtonEntityInterface

type CommonOpenUrlActionButtonEntityInterface =
  | OpenUrlActionButtonEntityInterface
  | OpenUrlWebsiteActionButtonEntityInterface

export const ButtonOpenUrlActionSettings = ({
  entity,
}: SettingsProps<CommonActionButtonEntityInterface>) => {
  const { t } = useTypedTranslation()
  const updateProp = useUpdateProp(
    entity as CommonOpenUrlActionButtonEntityInterface,
  )

  usePreserveEntityFieldsAcrossDiscriminator({
    entity: entity as CommonOpenUrlActionButtonEntityInterface,
    discriminator: [{ key: 'action', value: ButtonActionTypeEnum.OpenUrl }],
    preservedKeys: ['linkUrl', 'linkTarget', 'rel'],
  })

  return entity.action === ButtonActionTypeEnum.OpenUrl ? (
    <ButtonLinkActionSettingsLayout
      entity={entity as CommonOpenUrlActionButtonEntityInterface}
    >
      <TextInputControl
        wrapperProps={{
          labelText: 'url',
        }}
        update={updateProp('linkUrl')}
        placeholder={t('entity_settings.button.url_input.placeholder')}
        value={entity.linkUrl}
        onBlur={() =>
          updateProp('linkUrl')(addUrlSchemaToTheLink(entity.linkUrl ?? ''))
        }
        removeWhitespaces
      />
    </ButtonLinkActionSettingsLayout>
  ) : null
}
